import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-20",
  "use": "icon-20-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-20\"><defs><style> </style></defs><path class=\"a\" d=\"M159.88,824.52a8,8,0,1,1,8-8,8,8,0,0,1-8,8Zm0-1.333a6.667,6.667,0,1,0-6.667-6.667,6.667,6.667,0,0,0,6.667,6.667Zm-.667-7.333a.667.667,0,0,1,1.333,0v4.667a.667.667,0,1,1-1.333,0Zm.6-2.133a.933.933,0,1,1,.933-.933.933.933,0,0,1-.933.933Zm0,0\" transform=\"translate(-151.88 -808.52)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol